<template>
  <div class="mod">
    <div class="mod-nav">
      <a v-for="(item, index) in modList" class="nav-item" :class="{ active : modNavIndex === index }" href="javascript: void(0)" @click="modNavFn(index)">{{ item.text }}</a>
    </div>

    <div class="mod-content">
      <div class="model-item" :class="{ active : modNavIndex === modList[0].index }">
        <div class="setp-nav">
          <div v-for="(item, index) in stepList" class="step-item link-itme">
            <a class="link-itme" :class="[item.cls, { active : setpNavIndex === index }]" href="javascript: void(0)" @click="setpNavIndexFn(index)">{{ item.text }}</a>
          </div>
        </div>

        <div class="setp-content">
          <div class="step-item" :class="{ active : setpNavIndex === stepList[0].index }">
            <ol class="step-list">
              <li class="list-item">
                <p>1.下载windows版开发插件。</p>
                <!--<a class="link" href="javascript: void(0)">点击下载</a>-->
              </li>

              <li class="list-item">
                <p>2.下载windows版unity客户端。</p>
              </li>

              <li class="list-item">
                <p>3.下载开发者文档。</p>
              </li>

              <li class="list-item">
                <p>4.安装unity并完成注册</p>
              </li>

              <li class="list-item">
                <p>5.使用unity打开创造与魔法开发工具包Creation & Magic Development Kit工程，第一次运行会hold一会，请耐心等待</p>
                <div class="images-box">
                  <img src="./img/step-1-image.png" alt="截图"/>
                </div>
              </li>
            </ol>
          </div>

          <div class="step-item" :class="{ active : setpNavIndex === stepList[1].index }">
            <ol class="step-list">
              <li class="list-item">
                <p>1.使用开发者账户登陆</p>
                <div class="images-box">
                  <img src="./img/step-2-image-1.png" alt="截图"/>
                </div>
              </li>

              <li class="list-item">
                <p>2.创建一张地图，给地图起一个名字和匹配模式</p>
                <p>1)匹配模式支持1~5排</p>
                <p>2)X排指一个基础小队的人数上限，比如2排就是一个基础小队是2人</p>
                <p>3)最大队伍是地图开启需要的队伍数量，如图2排，最大队伍2，就是需要2*2四个玩家可以进行游戏</p>
                <div class="images-box">
                  <img src="./img/step-2-image-2.png" alt="截图"/>
                </div>
              </li>

              <li class="list-item">
                <p>3.建立好地图之后，可以使用辅助工具制作地图内容，首先要创建一张大陆</p>
                <div class="images-box">
                  <img src="./img/step-2-image-3.png" alt="截图"/>
                </div>
              </li>

              <li class="list-item">
                <p>4.大陆创建好之后可以制作怪物等等，需要使用mine_data的表格，详情请阅读开发文档说明，编辑完毕表格，使用导出客户端表和导出服务器表可以导出客户端和服务器使用的文件格式</p>
              </li>

              <li class="list-item">
                <p>5.请在mine_server中修改fuc10000的lua脚本，可以使用notepad++打开，该脚本为mod的服务器脚本文件</p>
              </li>

              <li class="list-item">
                <p>6.请在mine_client中修改客户端资源文件，该目录为客户端资源文件和脚本文件位置</p>
              </li>

              <li class="list-item">
                <p>7.调试工具，制作好地图之后可以使用调试工具上传服务器资源，将mine_server中的脚本文件上传</p>
              </li>

              <li class="list-item">
                <p>8.使用SCENES中的login场景，打开后运行，即可进行游戏的调试。</p>
              </li>
            </ol>
          </div>

          <div class="step-item" :class="{ active : setpNavIndex === stepList[2].index }">
            <ol class="step-list">
              <li class="list-item">
                <p>1.地图制作完成后，可以使用发布工具将地图发布到测试区给玩家测试</p>
              </li>

              <li class="list-item">
                <p>2.首先使用资源打包功能，将打包mine_client和mine_server的资源打包</p>
              </li>

              <li class="list-item">
                <p>3.打包成功后使用提交测试区审核按钮将资源上传，资源上传成功后前往开发者后台进行审核申请</p>
                <div class="images-box">
                  <img src="./img/step-3-image-1.png" alt="截图"/>
                </div>
              </li>

              <li class="list-item">
                <p>4.在开发者后台提交审核完善信息后等待审核</p>
                <div class="images-box">
                  <img src="./img/step-3-image-2.png" alt="截图"/>
                </div>
              </li>

              <li class="list-item">
                <p>5.审核通过后，在游戏的创意工坊中即可提供玩家试玩游戏了~</p>
              </li>
            </ol>
          </div>

          <div class="step-item" :class="{ active : setpNavIndex === stepList[3].index }">
            <ol class="step-list">
              <li class="list-item">
                <p>正式区内容正在研发中，敬请期待。</p>
              </li>
            </ol>
          </div>
        </div>
      </div>

      <div class="model-item" :class="{ active : modNavIndex === modList[1].index }">
        <p class="desc">私服模式正在研发中，敬请期待。</p>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  export default {
    name: 'faqNew',
    data () {
      return {
        // 模式导航索引
        modNavIndex: 0,
        // 教程索引
        setpNavIndex: 0,
        // 模式
        modList: [
          {
            index: 0,
            text: '地图模式'
          },
          {
            index: 1,
            text: '私服模式'
          }
        ],
        // 模式索引
        modIndexList: [
          {
            index: 0
          },
          {
            index: 1
          }
        ],
        // 地图模式进度
        stepList: [
          {
            index: 0,
            cls: 'step1',
            text: '下载和安装'
          },
          {
            index: 1,
            cls: 'step2',
            text: '使用插件'
          },
          {
            index: 2,
            cls: 'step3',
            text: '发布测试区'
          },
          {
            index: 3,
            cls: 'step4',
            text: '发布正式区'
          }
        ]
      }
    },
    methods: {
      // 教程模式索引切换
      modNavFn (index) {
        this.modNavIndex = index
      },
      // 教程进度索引切换
      setpNavIndexFn (index) {
        this.setpNavIndex = index
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "faqNew.styl";
</style>



// WEBPACK FOOTER //
// src/views/faqNew/faqNew.vue